import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState } from 'react';
import Header from './shared/Header';
import LoadingWrapper from './shared/LoadingWrapper';

import AboutPage from './pages/About';

import ContactPage from './pages/Contact';
import NavinaPage from './pages/works/Navina';
import NavinaRiskPage from './pages/works/NavinaRisk';
import HomePage from './pages/Home';
import AstrixPage from './pages/works/Astrix';
import OtterizePage from './pages/works/Otterize';
import VayyarPage from './pages/works/Vayyar';
import SparkPage from './pages/works/Spark';
import KomodorPage from './pages/works/Komodor';
import ArrowsPage from './pages/works/Arrows';
import ClariterPage from './pages/works/Clariter';
import GeoxITCPage from './pages/works/geoxITC';
import WorksPage from './pages/Works';
import Footer from './shared/Footer';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import IndexPage from './pages/Index';
import RtmiCapitalPage from './pages/works/RtmiCapital';
import ProdopPage from './pages/works/Prodop';



const App = () => {




  return (
    <div className="bg-light">
    <BrowserRouter>
      <LoadingWrapper>
        <Header/>
          <Routes>

            <Route index element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/works" element={<WorksPage />} />

            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

            <Route path="/navina" element={<NavinaPage />} />
            <Route path="/prodop" element={<ProdopPage />} />
            <Route path="/navina-risk" element={<NavinaRiskPage />} />
            <Route path="/rtmi-capital" element={<RtmiCapitalPage />} />
            <Route path="/geoxITC" element={<GeoxITCPage />} />
            <Route path="/clariter" element={<ClariterPage />} />
            <Route path="/arrows" element={<ArrowsPage />} />
            <Route path="/otterize" element={<OtterizePage />} />
            <Route path="/vayyar" element={<VayyarPage />} />
            <Route path="/astrix" element={<AstrixPage />} />
            <Route path="/spark" element={<SparkPage />} />
            <Route path="/komodor" element={<KomodorPage />} />

          </Routes>
          <Footer/>
        </LoadingWrapper>
      </BrowserRouter>

      </div>
  );
}

export default App;
